/*********************
 * 📄 페이지 콘텐츠 정의
 * 
 * - 메인 페이지의 슬라이드 및 서비스 콘텐츠
 * - i18n 키를 반환하여 번역 지원
 *********************/

interface homeTabContent {
  titleKey: string
  subTitleKey: string
}

interface serviceTabContent {
  titleKey: string
  contentKey: string
}

export const homeTabContents = (): homeTabContent[] => {
  return [
    {
      titleKey: 'main.home.slide1.title',
      subTitleKey: 'main.home.slide1.subtitle',
    },
    {
      titleKey: 'main.home.slide2.title',
      subTitleKey: 'main.home.slide2.subtitle',
    },
    {
      titleKey: 'main.home.slide3.title',
      subTitleKey: 'main.home.slide3.subtitle',
    },
  ]
}

export const serviceTabContents = (): serviceTabContent[] => {
  return [
    {
      titleKey: 'main.service.items.registration.title',
      contentKey: 'main.service.items.registration.content',
    },
    {
      titleKey: 'main.service.items.promotion.title',
      contentKey: 'main.service.items.promotion.content',
    },
    {
      titleKey: 'main.service.items.logistics.title',
      contentKey: 'main.service.items.logistics.content',
    },
    {
      titleKey: 'main.service.items.resources.title',
      contentKey: 'main.service.items.resources.content',
    },
  ]
}
